import ouiBase from '@goldwasserexchange/oui';
import { useAccountPositionFieldApiByGesEstimD } from '../api';

export const useAccountPositionGesEstimDExRateBuy = () => {
  const gesEstimDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountPositionFieldApiByGesEstimD({
    gesEstimDId,
    field: 'GES_ESTIM_D.EXRATE_BUY',
  });
  return result;
};
